export enum FormErrorCode {
  Required = 'This field is required!',
  Email = 'Email is not correct!',
  ZipCode = 'Invalid zip code!',
  CreditCard = 'Invalid credit card number!',
  CVC = 'CID of credit card needs to be a minimum of 3 characters long!',
  PhoneNumber = 'Invalid phone number!',
  StreetAddress = 'Enter a street address to get your package faster',
  EnglishAlphabet = 'Please use English alphabet!',
  Alphabet = 'Please use only alphabet!',
  BadWords = 'Please replace the highlighted text',
  HTML = 'HTML is not allowed to submit!',
}

export const isZipCode = (isoCountryName?: string, value?: string) => {
  if (!value) return true;
  if (isoCountryName === 'US' || isoCountryName === 'USA') {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
  }
  if (isoCountryName === 'Canada') {
    return /^([a-z|A-Z][0-9][a-z|A-Z])\s*([0-9][a-z|A-Z][0-9])$/.test(value);
  }

  return value.length >= 3;
};

export const isEmail = (value: string | null): boolean => {
  const pattern =
    /^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

  if (value === null || value === '') {
    return false;
  }

  const isValidFormat = pattern.test(value);
  if (!isValidFormat) {
    return false;
  }

  return true;
};

export const ascii =
  (callBack: () => void, alertMessage: string) =>
  (value?: string): boolean => {
    if (value) {
      const regExp: RegExp = /[^\x00-\x7F\u{0080}-\u{10FFFF}]/gu;
      const isEnglish = regExp.test(value);

      if (!isEnglish) return true;

      callBack();
      window.alert(alertMessage);
      return false;
    }

    return false;
  };
